import { base64ToBin } from "@bitauth/libauth";
import { OpReturnData, SendRequest, TokenSendRequest, } from "../wallet/model.js";
export function asSendRequestObject(requests) {
    let resp = [];
    if (Array.isArray(requests)) {
        requests.forEach((r) => {
            // the SendRequestArray[] case
            if (Array.isArray(r)) {
                if (r[0] === "OP_RETURN") {
                    // ['OP_RETURN', utf8ToBin('MEMO\x10')],
                    resp.push(OpReturnData.from(r[1]));
                }
                else if (r[0] === "OP_RETURNB64") {
                    resp.push(OpReturnData.fromUint8Array(Uint8Array.from(base64ToBin(r[1]))));
                }
                else {
                    // ['cashaddr', 120] or ['cashaddr', 120n],
                    resp.push(new SendRequest({
                        cashaddr: r[0],
                        value: typeof r[1] === "number"
                            ? BigInt(Math.floor[1])
                            : r[1],
                    }));
                }
            }
            else {
                // SendRequest | TokenSendRequest | OpReturnRequest case
                resp.push(convertToClass(r));
            }
        });
    }
    else {
        // the SendRequest | OpReturnData object case
        resp.push(convertToClass(requests));
    }
    return resp;
}
function convertToClass(object) {
    if (object.hasOwnProperty("category")) {
        return new TokenSendRequest(object);
    }
    else if (object.hasOwnProperty("buffer")) {
        return OpReturnData.fromUint8Array(object.buffer);
    }
    // endcoding in REST
    else if (object.hasOwnProperty("dataString")) {
        return OpReturnData.fromString(object.dataString);
    }
    else if (object.hasOwnProperty("dataBuffer")) {
        return OpReturnData.fromUint8Array(Uint8Array.from(base64ToBin(object.dataBuffer)));
    }
    else if (object.hasOwnProperty("cashaddr") &&
        object.hasOwnProperty("value") &&
        object.hasOwnProperty("category") === false) {
        return new SendRequest(object);
    }
    throw new Error("Unsupported send object");
}
//# sourceMappingURL=asSendRequestObject.js.map